import { Stack, Typography } from "@mui/material";
import { OneTimeProduct } from "src/api/types";
import WhiteCard from "src/shared/components/WhiteCard";
import ProductCard from "../ProductCard";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

interface Props {
  productSlug: string;
  products: OneTimeProduct[];
  numberOfMonths: number;
  order?: number;
}

const ProductsList = ({
  productSlug,
  products,
  numberOfMonths,
  order,
}: Props) => {
  const { t } = useTranslation();
  const component = "patient-dashboard.oneTimeProducts";

  const header = useMemo(() => {
    const emoji = numberOfMonths === 1 ? "⭐" : "🏆";

    return `${emoji} ${t(
      `${component}.${productSlug}.${numberOfMonths}-month.header`
    )}`;
  }, [numberOfMonths, productSlug, t]);

  return (
    <WhiteCard gap={2} sx={{ order: order }}>
      <Stack gap={0.5}>
        <Typography variant="h6" fontWeight={600}>
          {header}
        </Typography>
        <Typography variant="subtitle2">
          {t(`${component}.${numberOfMonths}-month.subheader`)}
        </Typography>
      </Stack>
      <Stack gap={2}>
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </Stack>
    </WhiteCard>
  );
};

export default ProductsList;
